import React, { useRef, useState } from 'react';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';

const Futbol = () => {
  const galleryRef = useRef();
  const [showMore, setShowMore] = useState(false);

  const handleViewGolazo = () => {
    galleryRef.current?.openGallery(0);
  };

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <section id="futbol" className="section futbol-section">
      <div className="section-header">
        <img src="/images/futbol.png" alt="Futbol" className="section-icon" />
        <h1>Futbol, Calcio, Soccer...</h1>
      </div>
      <p>
        The <b>Beautiful Game</b> that unites the world! Football (or soccer) is the most popular sport globally, bringing together billions of fans across continents.  From the World Cup to local leagues, futbol represents passion, skill, teamwork, and the pure joy of competition on the pitch.
      </p>

         {showMore && (
          <div className="extended-intro">
            <p>The passion that I have for Futbol, the passion my family has for Futbol. I can't explain it, I can't put it into words, it's a feeling, it's a way of life, it's religion, politics, war & peace.</p>
          </div>
        )}

      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleCelebration}>
          <i className="fas fa-trophy"></i>
          {showMore ? 'Less' : '90+'}
        </button>

        <button className="cta-btn secondary" onClick={handleViewGolazo}>
          <i className="fas fa-futbol"></i>
          Golazo
        </button>
      </div>
      
      <Gallery ref={galleryRef} images={galleryData.futbol} sectionName="Futbol is Life" maxDisplay={4} />
    </section>
  );
};

export default Futbol;
